import { render, staticRenderFns } from "./SmTableCollationResult.vue?vue&type=template&id=18da9397&scoped=true&"
import script from "./SmTableCollationResult.vue?vue&type=script&lang=ts&"
export * from "./SmTableCollationResult.vue?vue&type=script&lang=ts&"
import style0 from "./SmTableCollationResult.vue?vue&type=style&index=0&id=18da9397&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18da9397",
  null
  
)

export default component.exports